<template>
  <van-image
    class="app-image"
    :src="src"
    :alt="alt"
    :lazy-load="lazyLoad"
    v-bind="$attrs"
  >
    <template #loading>
      <van-loading type="spinner" size="20" />
    </template>
    <template #error>
      <van-icon name="photo-fail" size="20" />
    </template>
  </van-image>
</template>

<script setup>
defineOptions({
  inheritAttrs: false
});

defineProps({
  src: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  },
  lazyLoad: {
    type: Boolean,
    default: true
  }
});
</script>

<style scoped>
.app-image {
  max-width: 100%;
  overflow: hidden;
}

.app-image :deep(.van-image__img) {
  max-width: inherit;
  max-height: inherit;
  border-radius: inherit;
  object-fit: inherit;
  object-position: inherit;
  display: block;
}

.app-image :deep(.van-image__loading),
.app-image :deep(.van-image__error) {
  background: #f4f5f6;
  color: #999;
}
</style>
